import styled from "styled-components"
import {Modal} from "react-bootstrap"

export default styled(Modal)`
  .modal-content {
    margin: 100px auto;
    width: 476px;
  }
`
